module.exports = __webpack_public_path__ + "img/qq6.9c33c79a.jpg";